import "/src/style/generalStyle.css";
import "/src/style/csvInputStyle.css";

export function CsvInputView(props) {
    function fileInputEventACB() {
        const file = document.querySelector(".csvInput").files[0];
        if (!file) {
            console.error("No file selected!");
            return;
        }
        props.fileWasInputACB(file);
    }
    return (
        <div>
            <div className="inputBox">
                <input className="csvInput" type="file" accept=".csv"></input>
                <button className="doInputButton" onClick={fileInputEventACB}>Upload CSV</button>
            </div>
        </div>
    );
}